// Flanking hairlines for the 18px (spacing-6) custom scrollbar gutter —
// Figma node 10931:136591. Intended to be rendered inside a `relative`
// container and gated on `isScrollable` so they only appear when content
// actually overflows.
export function ScrollbarHairlines() {
  return (
    <>
      <div
        aria-hidden="true"
        className="pointer-events-none absolute right-6 top-0 bottom-0 z-30 w-px bg-dinnerplate-white"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute right-0 top-0 bottom-0 z-30 w-px bg-dinnerplate-white"
      />
    </>
  );
}
